/*!
 * Copyright (c) 2024 Gateway Forge LLC.
 * All rights reserved.
 *
 * This software and its source code are proprietary and confidential to Gateway Forge LLC.
 * Unauthorized copying, distribution, or modification is prohibited.
 */

import { appReducer, initialAppState } from "./appReducer";
import { initialThemeState, themeReducer } from "./themeReducer";







export const initialState = {
    app: initialAppState,
    theme: initialThemeState,

};



export const reducers = {
    app: appReducer,
    theme: themeReducer,

}